import FolderIcon from '@mui/icons-material/Folder'
import { Typography } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import { Icon } from 'components/icon'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { File } from '../../models'
import { TextField } from 'components/textField'
import { FormControl, FormLabel } from '@mui/material'
import { useClickOutside } from 'util/util'

export interface IFileListProps {
  files?: File[]
  isEdit?: boolean
  onDelete?: (file: File) => void
}

export const FileList: FC<IFileListProps> = ({
  files,
  isEdit,
  onDelete,
}: IFileListProps): JSX.Element => {
  const [fileToEdit, setFileToEdit] = React.useState<File>(null)

  const wrapperRef = React.useRef<HTMLDivElement>(null)
  useClickOutside(wrapperRef, () => setFileToEdit(null))

  const { t } = useTranslation()

  return (
    <Box display='flex' flexDirection='column' flex='1' width='100%'>
      {files.length > 0 && <Typography>{t('files')}</Typography>}
      <List dense={true} disablePadding>
        {files.map((f) => (
          <ListItem
            key={f.id + '-' + f.key}
            divider
            secondaryAction={
              isEdit ? (
                <Box
                  display='flex'
                  flexDirection='row'
                  gap={fileToEdit ? 0 : 4}
                >
                  {!fileToEdit ? (
                    <IconButton
                      edge='end'
                      aria-label='edit'
                      onClick={() => setFileToEdit(f)}
                    >
                      <Icon iconId='settings' />
                    </IconButton>
                  ) : (
                    <IconButton
                      edge='end'
                      aria-label='save'
                      onClick={() => setFileToEdit(null)}
                    >
                      <Icon iconId='publish' />
                    </IconButton>
                  )}
                  {!fileToEdit && (
                    <IconButton
                      edge='end'
                      aria-label='delete'
                      onClick={() => onDelete(f)}
                    >
                      <Icon iconId='bin' />
                    </IconButton>
                  )}
                </Box>
              ) : null
            }
          >
            <ListItemAvatar
              onClick={() => f.openInWindow()}
              sx={{ cursor: 'pointer' }}
            >
              <Avatar>
                <FolderIcon />
              </Avatar>
            </ListItemAvatar>
            {isEdit && fileToEdit && fileToEdit.id == f.id ? (
              <FormControl
                ref={wrapperRef}
                sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
                margin='normal'
              >
                <FormLabel>{t('title')}</FormLabel>
                <TextField
                  sx={{ width: '100%' }}
                  hiddenLabel
                  variant='outlined'
                  value={fileToEdit.title}
                  onChange={(e) =>
                    fileToEdit.set('title', e.target.value, true)
                  }
                />
                <FormLabel>{f.mime_type}</FormLabel>
              </FormControl>
            ) : (
              <ListItemText
                primary={f.title}
                secondary={f.mime_type}
                onClick={() => f.openInWindow()}
                sx={{ cursor: 'pointer' }}
              />
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  )
}
